<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <div class="d-flex align-items-center">
                            <p class="mb-0">Configuración de Precio</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <form @submit.prevent="submit">
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Código</label
                                    >
                                    <argon-input id="code"
                                    type="text" v-model="price.code" 
                                    />
                                    <small v-if="submitted && v$.price.code.$error" class="text-danger">Código de examen es requerido</small>
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Descripción</label
                                    >
                                    <argon-input type="text" v-model="price.description" />
                                    <small v-if="submitted && v$.price.description.$error" class="text-danger">Descripción de examen es requerido</small>
                                </div>
                                <div class="col-md-2">
                                    <label for="example-text-input" class="form-control-label"
                                    >¿Activo?</label
                                    >
                                    <argon-switch type="text" variant="info" v-model="price.status" :checked="price.status"/>
                                </div>
                                <div class="col-md-2">
                                    <label for="example-text-input" class="form-control-label"
                                    >Presentar por defecto</label
                                    >
                                    <argon-switch type="text" variant="info" v-model="price.first" />
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <label for="example-text-input" class="form-control-label"
                                                >Exámen</label
                                                >
                                                <argon-select class="form-control" ref="testText" type="text" v-model="price_deatil.test_id" :choices="tests" @change="setName($event)"/>
                                            </div>
                                            <div class="col-md-2">
                                                <label for="example-text-input" class="form-control-label"
                                                >Precio</label
                                                >
                                                <argon-input-number id="code"
                                                type="number" v-model="price_deatil.unit_price" :min="0" :max="999999"
                                                />
                                            </div> 
                                            <div class="col-md-2">
                                                <label for="example-text-input" class="form-control-label"
                                                >Descuento</label
                                                >
                                                <argon-input-number id="code"
                                                type="number" v-model="price_deatil.discount" :min="0" :max="100"
                                                />
                                            </div>
                                            <div class="col-md-4">
                                                <argon-button 
                                                class="mt-4"
                                                variant="gradient"
                                                color="info"
                                                fullWidth
                                                size="lg"
                                                @click="insertPriceDetail"
                                                >Agregar precio</argon-button>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="card">
                                                    <div class="card-header pb-0">
                                                        <div class="row">
                                                            <div class="col-md-10">
                                                                <h6>Exámenes y precios</h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="card-body px-0 pt-0 pb-2">
                                                        <div class="table-responsive p-0">
                                                            <table class="table align-items-center mb-0">
                                                                <thead>
                                                                    <tr>
                                                                        <th
                                                                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                                                                        >Examen</th>
                                                                        <th
                                                                        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                                                                        >Precio</th>
                                                                        <th
                                                                        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                                                                        >Descuento</th>
                                                                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr 
                                                                        v-for="(
                                                                        {
                                                                            unit_price,
                                                                            discount,
                                                                            test_name
                                                                        },
                                                                        index
                                                                        ) of priceDetailsRows"
                                                                        :key="index"
                                                                    > 
                                                                        <td>
                                                                            <div class="d-flex px-2 py-1">
                                                                                <div class="d-flex flex-column justify-content-center">
                                                                                    <h6 class="mb-0 text-sm">{{ test_name }}</h6>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div class="d-flex px-2 py-1">
                                                                                <div class="d-flex flex-column justify-content-center">
                                                                                    <h6 class="text-xs font-weight-bold mb-0 text-center">{{ unit_price }}</h6>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div class="d-flex px-2 py-1">
                                                                                <div class="d-flex flex-column justify-content-center text-center">
                                                                                    <h6 class="mb-0 text-sm">{{discount}}</h6>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td >
                                                                            <div class="d-flex px-2 py-1">
                                                                                <div class="d-flex flex-column justify-content-center text-center">
                                                                                    <a
                                                                                        @click="removePriceDetail(index)"
                                                                                        class="btn btn-xs bg-gradient-danger"
                                                                                    >Quitar</a>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <argon-button
                            type="submit" 
                            class="mt-4"
                            variant="gradient"
                            color="info"
                            fullWidth
                            size="lg"
                            @click="insertPrice"
                            >Guardar</argon-button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonInputNumber from "@/components/ArgonInputNumber.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonSelect from "@/components/ArgonSelect.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import {useVuelidate} from '@vuelidate/core';
import {required} from  '@vuelidate/validators';
import axios from "axios";

export default {
    name: "company",
    setup:() => ({ v$: useVuelidate() }), 
    data() {
        return {
            showMenu: false,
            submitted:false,
            test_name:null,
            tests:[],
            price:{
                action:'add',
                object:'prices',
                code:null,
                description:null,
                status:0,
                first:0,
                company_id:1
            },
            price_deatil:{
                action:'add',
                object:'prices_detail',
                price_id:0,
                unit_price:0,
                test_id:0,
                discount:0
            },
            priceDetailsRows:[],
        };
    },
    components: {
        ArgonInput, 
        ArgonInputNumber,
        ArgonSwitch,
        ArgonButton, 
        ArgonSelect,
    },
    validations(){
        return{
            price:{
                code:{required},
                description:{required},
            },
        }
    },
    methods:{
        async fetchTests(config){
            let self=this;
            fetch(this.$store.state.apiURL+'?action=list&object=test&recperpage=all', config)
            .then(response=>response.json())
            .then(result=> {
                console.log(result);
                this.tests=result.test.map(item=>{return{value:item.id, text:item.code+' '+item.description}})
            })
            .catch(error => {
                console.log(error)
                self.$swal({
                    title: 'Sesión',
                    text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                    type: 'warning',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#bf4f51',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });    
            });
        },
        insertPrice(){
            let self= this;
            this.submitted = true;
            this.v$.$touch();
            if(!this.v$.$invalid){
                const token = localStorage.getItem("accessToken");
                const config = {headers: {"Authorization": `Bearer ${token}`}};
                console.log(this.price)
                axios.post(this.$store.state.apiURL, this.price, config)
                .then((result)=>{
                    console.log(result);
                    this.priceDetailsRows.forEach(function (item){
                        item.price_id= result.data.prices.id
                    })
                    let request = this.priceDetailsRows.map(items=> axios.post(this.$store.state.apiURL,items, config));
                    axios.all(request)
                    .then((resultAll)=>{
                        console.log(resultAll)
                        self.$swal({
                            title: 'Actualización de datos',
                            text: 'Se insertó la información de precios de manera satisfactoria',
                            type: 'success',
                            icon:'success',
                            showCancelButton: false,
                            confirmButtonColor:'#bf4f51',
                            showCloseButton: true,
                            showLoaderOnConfirm: false  
                        }).then(function(){
                            self.$router.push('/prices-settings');
                        });
                    })
                    
                })
            }else{
                self.$swal({
                    title: 'Error en validación',
                    text: 'Encontramos algunos datos incorrectos',
                    type: 'error',
                    icon:'error',
                    showCancelButton: false,
                    confirmButtonColor:'#bf4f51',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                });
            } 
            
        },
        setName(event){
            //console.log(event);
            this.test_name = event.target.options[event.target.options.selectedIndex].text;
            //console.log(this.test_name);
        },
        insertPriceDetail(){
            console.log(this.$refs.testText);
            let priceDetail= {
                action:'add',
                object:'prices_detail',
                unit_price:this.price_deatil.unit_price,
                discount:this.price_deatil.discount,
                test_id:this.price_deatil.test_id,
                price_id:this.price_deatil.price_id,
                test_name:this.test_name
            };
            this.priceDetailsRows.push(priceDetail);
            this.price_deatil.unit_price=0;
            this.price_deatil.discount=0;
            this.price_deatil.test_id=null;
            this.test_name=null;
        },
        removePriceDetail(indexVal){
            console.log(indexVal)
            this.priceDetailsRows.splice(indexVal);
        }
    },
    mounted() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"Authorization": `Bearer ${token}`}};
        this.fetchTests(config);
    },
    beforeMount() {

    },
    beforeUnmount() {

    }
};
</script>